<template>
  <div class="content">
    <div class="container-fluid">
        <h2>You have to update your bookmarks! </h2>
        <h3>The Costs Dashboard moved to a new location</h3>
            <br/>You will be redirected in  {{ countdown }} seconds
    </div>
  </div>
</template>

<script>

    import { setInterval } from 'timers';

    export default {
        created() {
          var vm = this
          setInterval(function(){
            vm.countdown -= 1
          },1000)

        },
        watch: {
            countdown:function (){
                if (this.countdown == 0) {
                    window.location.href = 'https://dashboard.ceg.olx.org';
                }
            }
        },
        data() {
            return {
                countdown: 10
            }
        }
    }
</script>